// Shared horizontal-scroll carousel behavior for any ".catalog-carousel" on
// the page (main-list-collections.liquid, main-past-catalogs.liquid).
// Initializes every instance found, so a page can render more than one.
(function () {
  function initCarousel(carousel) {
    var rail = carousel.querySelector('.catalog-rail');
    var fill = carousel.querySelector('.carousel-progress-bar-fill');
    var prev = carousel.querySelector('.catalog-arrow--prev');
    var next = carousel.querySelector('.catalog-arrow--next');
    if (!rail || !prev || !next) return;

    function update() {
      var max = rail.scrollWidth - rail.clientWidth;
      var pct = max > 0 ? rail.scrollLeft / max : 0;
      if (fill) fill.style.width = (pct * 100) + '%';
      prev.disabled = rail.scrollLeft <= 1;
      next.disabled = max <= 0 || rail.scrollLeft >= max - 1;
    }

    function cardWidth() {
      var card = rail.querySelector('.catalog-card');
      return card ? card.offsetWidth : 550;
    }

    prev.addEventListener('click', function () {
      rail.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      rail.scrollBy({ left: cardWidth(), behavior: 'smooth' });
    });

    var drag = { active: false, startX: 0, scrollStart: 0, moved: false };

    rail.addEventListener('mousedown', function (e) {
      drag.active = true;
      drag.startX = e.clientX;
      drag.scrollStart = rail.scrollLeft;
      drag.moved = false;
      rail.style.cursor = 'grabbing';
      e.preventDefault();
    });

    window.addEventListener('mousemove', function (e) {
      if (!drag.active) return;
      var delta = drag.startX - e.clientX;
      if (Math.abs(delta) > 4) drag.moved = true;
      if (drag.moved) { rail.scrollLeft = drag.scrollStart + delta; update(); }
    });

    window.addEventListener('mouseup', function () {
      if (!drag.active) return;
      drag.active = false;
      rail.style.cursor = 'grab';
    });

    rail.addEventListener('click', function (e) {
      if (drag.moved) { e.preventDefault(); drag.moved = false; }
    }, true);

    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    requestAnimationFrame(update);
  }

  document.querySelectorAll('.catalog-carousel').forEach(initCarousel);
})();
